import { PatchCustomersCurrentApiResponse } from 'core_main/api/customers/types';
import {
  DescribeCustomerParametersAttributes,
  DescribeCustomerCallbackResponse,
} from './types';

export const formatAttributes = (
  attributes?: DescribeCustomerParametersAttributes,
) => {
  if (!attributes) return {};

  const entries = Object.entries(attributes);

  return entries.reduce((acc, val) => {
    const key = val[0] as keyof DescribeCustomerParametersAttributes;
    const value = val[1] as [];

    let values;

    if (key === 'phones') {
      values = value.map((val) => ({
        phone: val,
      }));
    }

    if (key === 'emails') {
      values = value.map((val) => ({
        email: val,
      }));
    }

    acc[key] = values || value;

    return acc;
  }, {});
};

export const createDescribeCustomerCallbackResponse = (
  response: PatchCustomersCurrentApiResponse,
): DescribeCustomerCallbackResponse => {
  const { attributes, id } = response.data;
  const { custom } = attributes;

  const emails = attributes.sharedEmails?.map((val) => val.email);

  const phones = attributes.sharedPhones?.map((val) => val.phone);

  const socials = attributes.sharedSocials?.map((val) => ({
    username: val.username,
    type: val.type,
  }));

  return {
    customerId: id,
    custom,
    emails,
    phones,
    socials,
  };
};
